import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-footer-reusable',
  templateUrl: './footer-reusable.component.html',
  styleUrls: ['./footer-reusable.component.scss']
})
export class FooterReusableComponent implements OnInit {
  @Input() backgroundBody;
  styleExpression;

  constructor() { }

  ngOnInit(): void {
    this.styleExpression = {backgroundColor: this.backgroundBody}
  }

}
